import { alpha } from '@mui/material';
import { theme } from '../../../theme';
import { createMuiStyles } from '../../../utils/mui';

export const profileLayoutStyles = createMuiStyles({
  nav: {
    bgcolor: 'grey.50',
    py: 5,
    maxHeight: {
      lg: 'calc(100vh - 4rem)',
    },
    height: {
      lg: 1,
    },
    overflow: {
      lg: 'auto',
    },
    position: {
      lg: 'sticky',
    },
    top: {
      lg: 0,
    },
    width: '22.5rem',
    maxWidth: '100vw',
    pr: 2.5,
    pl: {
      xs: '2rem',
      lg: 'clamp(1rem, 4vw, 3rem)',
    },
  },
  navAvatar: {
    img: {
      borderRadius: 2,
      width: '6.25rem',
      height: '5rem',
      boxShadow: `0 0.25rem 0.5rem ${alpha(theme.palette.secondary.main, 0.1)}`,
      objectFit: 'cover',
      objectPosition: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    },
  },
  progressBar: {
    mt: 0.5,
    height: '.75rem',
    borderRadius: '1rem',
    '.MuiLinearProgress-bar': {
      borderRadius: 'inherit',
      bgcolor: 'primary.dark',
    },
  },
  navList: {
    ml: -2.5,
  },
  sectionName: {
    textTransform: 'uppercase',
    mb: 2,
    display: 'block',
  },
  navLink: {
    py: 2,
    px: 2.5,
    display: 'flex',
    width: 1,
    justifyContent: 'flex-start',
    color: 'grey.800',
    fontWeight: 'Regular',
    '&:hover, &:focus': {
      '&:not(.active)': {
        bgcolor: 'primary.light',
      },
    },
    '&.active': {
      bgcolor: 'primary.main',
      color: 'common.white',
    },
  },
  applySection: {
    pt: 1.5,
    borderTop: 1,
    borderColor: 'grey.200',
    ml: -2.5,
  },
  applyBtn: {
    justifyContent: 'space-between',
    bgcolor: 'grey.100',
    mb: 1,
    '&:hover, &:focus': {
      '&:not(.active)': {
        bgcolor: 'grey.300',
      },
    },
  },
  outletGridItem: {
    maxWidth: {
      lg: 'calc(100% - 22.5rem)', // 22.5rem is the width of sidebar "nav"
    },
  },
  outletWrapper: {
    py: 5,
    px: 'clamp(1rem, 4vw, 3rem)',
    pl: {
      lg: 4,
    },
  },
});
